module.exports = __webpack_public_path__ + "img/equipos-moviles-img-2.4803a1a4.jpg";